<router-outlet></router-outlet>

<sbl-version-renderer></sbl-version-renderer>
